import React from 'react';

import { createReactFormValidator, range, required, positiveInteger } from '../../../../../utils/validation';
import {
    Input,
    Select,
} from '../../../../Form';
import { acceptanceBucketTypes, SpecialExemptOptions } from '../../../../../utils/eventConstants';

const RankingBuckets = (props) => {
    const {
        field,
        buckets,
        division,
        divisionIndex,
        acceptanceListRoundTypes,
    } = props;

    const divisionBuckets = division.acceptance.list.buckets;

    const mainRound = acceptanceListRoundTypes.find(rt => rt.value === acceptanceBucketTypes.MAIN);
    const qualifyingRound = acceptanceListRoundTypes.find(rt => rt.value === acceptanceBucketTypes.QUALIFYING);

    const mainBucketCount = parseInt(divisionBuckets.find(b => b.type === mainRound.id)?.count) ?? null;
    const qualifyingBucketCount = parseInt(divisionBuckets.find(b => b.type === qualifyingRound.id)?.count) ?? null;

    return (
        <>
            {buckets.map((draw, j) => {
                let inputLabel = 'How many players will be accepted into qualifying draw based on WTA Ranking?';
                let inputMin = 0;
                let inputMax = qualifyingBucketCount ?? null;
                let inputValidators = createReactFormValidator([positiveInteger, range(0, qualifyingBucketCount ?? 256)]);

                if (draw.type === mainRound.id) {
                    inputLabel = 'How many players will be accepted into main draw based on WTA Ranking?';
                    inputMin = 1;
                    inputMax = parseInt ?? 256;
                    inputValidators = createReactFormValidator([required, range(1, mainBucketCount ?? 256), positiveInteger]);
                }

                return (
                    <>
                        <Input
                            id={`division-${divisionIndex}-acceptance-list-draw-count-by-ranking-${j}`}
                            key={`acceptance-list-draw-count-by-ranking-${j}`}
                            label={inputLabel}
                            field={[field, divisionIndex, 'acceptance', 'list', 'buckets', j, 'countByRanking']}
                            type="number"
                            min={inputMin}
                            max={inputMax}
                            validate={inputValidators}
                        />
                        {draw.type === mainRound.id && (
                            <Select
                                id={`division-${divisionIndex}-acceptance-list-draw-count-special-exempt-${j}`}
                                label="How many main draw spots would you like to save for special exempt players?"
                                field={[field, divisionIndex, 'acceptance', 'list', 'buckets', j, 'countSpecialExempt']}
                                optionsAsPrimitiveArray={true}
                                options={SpecialExemptOptions}
                                validate={createReactFormValidator(required)}
                            />
                        )}
                    </>
                );
            })}
        </>
    );
};

export default RankingBuckets;
